"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFloatingLinkEnter = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateLink = require("@udecode/plate-link");
var _submitFloatingLink = require("./submitFloatingLink");
var useFloatingLinkEnter = function useFloatingLinkEnter() {
  var editor = (0, _plateCommon.useEditorRef)();
  var open = (0, _plateLink.useFloatingLinkSelectors)().isOpen(editor.id);
  (0, _plateCommon.useHotkeys)('*', function (e) {
    if (e.key !== 'Enter') return;
    try {
      if ((0, _submitFloatingLink.submitFloatingLink)(editor)) {
        e.preventDefault();
      }
    } catch (error) {
      console.error(error);
    }
  }, {
    enableOnFormTags: ['INPUT'],
    enabled: open
  }, []);
};
exports.useFloatingLinkEnter = useFloatingLinkEnter;